import {propagate} from './propagate.js';

export default superclass => class extends superclass {
    propagate(action) {
        if (this.insideInstance()) {
            // only propagate if inside an instance
            propagate(this, action);
        }
    }
}
